// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"9014bf1f","969":"24b59c47"}[chunkId] + ".chunk.css";
};